import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatRadioChange } from '@angular/material';
import { State } from '@app/core/models/state-list.model';
import { CreditCard } from '../../../core/models';
import { EfilingService } from '../../../core/services/efiling.service';
import { CreditCardValidator } from '../../../core/validators/credit-card.validator';
import { MatSnackBar } from '@angular/material';
import { ConciergeService } from '@app/modules/services/concierge/concierge.service';
import { GlobalServiceDTO } from '@app/modules/filing-shared/global-shareval';

@Component({
  selector: 'credit-card-add',
  templateUrl: './credit-card-add.component.html',
  styleUrls: ['./credit-card-add.component.css']
})
export class CreditCardAddComponent implements OnInit {

  @Output() saveCreditCard = new EventEmitter<CreditCard>();
  @Output() creditCardPaymentTypeChange = new EventEmitter<number>();
  @Output() creditCardErrorMsg = new EventEmitter<boolean>();
  @Input() filingType: string;
  @Input() isFirmCard: string;
  @Input() concierge = false;
  @Input() conciergePayment = false;
  isVisible: boolean = true;
  years: string[];
  stateList: State[];
  creditCard: CreditCard;
  sCreditCard: CreditCard[];
  firmCreditCard: CreditCard;
  creditCardForm: FormGroup;
  newCreditCard: boolean = true;
  existingCCSelected: boolean;
  selectedNickName: boolean = false;
  vaultIDFromNickName: number;
  newCCSelected: boolean;
  visaChecked: boolean;
  existingCardAvl: boolean = false;
  selectedVaultId: number;
  existingCard: boolean = true;
  useThisCreditCard: boolean = false;
  existingPersonalCreditCard: boolean;
  existingFirmCreditCard: boolean;
  errorMsgDisplay: boolean = false;
  errorMsg: string;
  conciergeForm = this.fb.group({ conciergeCreditCard: [''] });
  conciergeCreditCard: CreditCard;
  sCard: CreditCard[];
  isNewCreditCard: boolean;
  paymentSelectionForm = this.fb.group({
    selectedVaultId: new FormControl('', { updateOn: 'blur' }),
  });

  checkNewCreditCard(event: any, type: string) {
    if (type != 'N') {
      this.isNewCreditCard = false;
      this.newCreditCard = true;
      this.errorMsgDisplay = false;
      this.existingPersonalCreditCard = true;
      this.existingFirmCreditCard = true;
      this.existingCCSelected = true;
      this.newCCSelected = false;
      this.selectedVaultId = null;
      this.useThisCreditCard = false;

    } else {
      this.isNewCreditCard = true;
      this.visaChecked = true;
      this.newCreditCard = false;
      this.errorMsgDisplay = false;
      this.existingPersonalCreditCard = false;
      this.existingFirmCreditCard = false;
      this.existingCCSelected = false;
      this.newCCSelected = true;
      this.useThisCreditCard = false;

      var obj = this.creditCardForm.get('paymentType').value;
      this.creditCardForm.get('firstName').setValue('');
      this.creditCardForm.get('lastName').setValue('');
      this.creditCardForm.get('nickName').setValue('');
      this.creditCardForm.get('address1').setValue('');
      this.creditCardForm.get('city').setValue('');
      this.creditCardForm.get('state').setValue('');
      this.creditCardForm.get('zipCode').setValue('');
      this.creditCardForm.get('creditCardNumber').setValue('');
      this.creditCardForm.get('securityCode').setValue('');
      this.creditCardForm.get('expirationMonth').setValue('');
      this.creditCardForm.get('expirationYear').setValue('');
      this.creditCardForm.get('rememberCreditCard').setValue(false);
      this.creditCardForm.get('paymentType').setValue('');
      if (this.isFirmCard) {
        this.creditCardForm.get('isFirmCard').setValue(1);
      }
      else {
        this.creditCardForm.get('isFirmCard').setValue(0);
      }
      this.sGlobalSerivceDTO.setIsNewCreditCard(this.isNewCreditCard);
    }
    this.creditCardForm.reset();
    this.efilingService.getUserCreditCard()
      .subscribe(result => {
        if (result.isSuccess) {
          const creditCardLoaded = result.data;
          this.sCreditCard = creditCardLoaded;

        }
        else
          console.error(result.message);
      }, error => console.error(error));
    this.errorMsgDisplay = false;
  }

  conciergePaymentCardToggle() {
    this.selectedVaultId = null;
    this.selectedVaultId = this.conciergeCreditCard.vaultsDTOs[0].id;
    this.vaultIDFromNickName = this.selectedVaultId;
    this.creditCard = this.conciergeCreditCard;
    // this.creditCard.id = this.vaultIDFromNickName;
    this.existingCard = false;
    this.saveCreditCard.emit(this.creditCard);
    this.creditCardPaymentTypeChange.emit(this.creditCard.paymentTypeId);
  }

  isNickNameCheck() {
    this.conciergeForm.controls.conciergeCreditCard.reset();
    this.sCard = [];
    this.vaultIDFromNickName = this.selectedVaultId;
    this.creditCard = this.creditCardForm.value;
    this.creditCard.id = this.vaultIDFromNickName;
    this.existingCard = false;
    this.saveCreditCard.emit(this.creditCard);
    this.sCard = this.sCreditCard.concat(this.firmCreditCard);
    const paymentTypeId = this.sCard.find(x => x.id == this.selectedVaultId).paymentTypeId;
    this.creditCardPaymentTypeChange.emit(paymentTypeId);

  }

  get creditCardFormControl() {
    return this.creditCardForm.get('creditCardNumber');
  }
  get creditCardNumberAsString() {
    return `xxxxxx${this.creditCard.creditCardNumber.substring(this.creditCard.creditCardNumber.length - 4, this.creditCard.creditCardNumber.length)}`;
  }

  get creditCardNumberInvalid() {
    return (this.creditCardFormControl.touched || this.creditCardFormControl.dirty) && !this.creditCardFormControl.valid;
  }

  constructor(
    private efilingService: EfilingService,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private conciergeService: ConciergeService,
    private sGlobalSerivceDTO: GlobalServiceDTO) {
      this.isNewCreditCard = this.sGlobalSerivceDTO.getIsNewCreditCard();
  }

  conciergeInit(): void {
    const work = this.conciergeService.currentWorkOrder.value;
    if (!!work) {
      this.conciergePayment = true;
      this.loadConciergePayment(work.conciergeId);
    }

    if (this.concierge) {
      this.creditCardForm.controls.nickName.clearValidators();
    }
  }

  ngOnInit(): void {

    this.efilingService.getAllStates()
      .subscribe(result => {
        if (result.isSuccess) {
          this.stateList = result.data;
        }
        else
          console.error(result.message);
      }, error => console.error(error));

    this.creditCardForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      nickName: ['', Validators.required],
      address1: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zipCode: ['', Validators.required],
      creditCardNumber: ['', [Validators.required, <any>CreditCardValidator.validateCCNumber]],
      securityCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
      expirationMonth: ['', Validators.required],
      expirationYear: ['', Validators.required],
      rememberCreditCard: [false],
      paymentType: ['', Validators.required],
      isFirmCard: [0]
    });

    this.conciergeInit();

    this.efilingService.getUserCreditCard()
      .subscribe(result => {
        if (result.isSuccess) {
          this.sCreditCard = result.data;
          if (this.sCreditCard[0]) {
            if (this.sCreditCard[0].nickName) {
              this.existingCardAvl = false;
              this.existingPersonalCreditCard = true;
              this.existingFirmCreditCard = false;
              this.existingCCSelected = true;
              this.newCreditCard = true;
              this.errorMsgDisplay = false;
            }
            else {
              this.existingCardAvl = true;
              this.existingPersonalCreditCard = false;
              this.existingFirmCreditCard = false;
              this.newCCSelected = true;
              this.newCreditCard = false;
              this.errorMsgDisplay = false;
            }
          }
          else {
            this.existingCardAvl = true;
            this.existingPersonalCreditCard = false;
            this.existingFirmCreditCard = false;
            this.newCCSelected = true;
            this.newCreditCard = false;
            this.errorMsgDisplay = false;
          }

          this.creditCardForm.get('firstName').setValue(this.sCreditCard[0].firstName);
          this.creditCardForm.get('lastName').setValue(this.sCreditCard[0].lastName);
          this.creditCardForm.get('nickName').setValue(this.sCreditCard[0].nickName);
          this.creditCardForm.get('address1').setValue(this.sCreditCard[0].address1);
          this.creditCardForm.get('city').setValue(this.sCreditCard[0].city);
          this.creditCardForm.get('state').setValue(this.sCreditCard[0].state);
          this.creditCardForm.get('zipCode').setValue(this.sCreditCard[0].zipCode);
          this.creditCardForm.get('expirationMonth').setValue(this.sCreditCard[0].expirationMonth);
          this.creditCardForm.get('expirationYear').setValue(this.sCreditCard[0].expirationYear);
          this.creditCardForm.get('rememberCreditCard').setValue(true);
          this.creditCardForm.get('paymentType').setValue(this.sCreditCard[0].paymentType);

        }
        else
          console.error(result.message);



        this.getUserFirmCreditCards();
      }, error => console.error(error));



    var currentYear = new Date().getFullYear();
    this.years = [];
    for (var i = 0; i < 12; i++) {
      this.years.push((currentYear + i).toString());
    }
    // this.creditCardPaymentTypeChange.emit(2);
  }

  private loadConciergePayment = (orderId: number) => {
    this.conciergeService
      .getConciergeCreditCard(orderId)
      .subscribe(result => {
        if (result.isSuccess) {
          this.conciergeCreditCard = result.data;
          this.selectedVaultId = this.conciergeCreditCard.vaultsDTOs[0].id;
          this.creditCardPaymentTypeChange.emit(this.conciergeCreditCard.paymentTypeId);
        }
      });
  };

  setCreditCardType() {
    const enteredCard = this.creditCardForm.get('creditCardNumber').value.replace(/ /g, '');
    if (enteredCard.length === 16) {
      if (enteredCard.match(/^5[1-5]\d{14}$/)) {
        this.setCard('3'); // mc
      } else if (enteredCard.match(/^4\d{15}/) || enteredCard.match(/^4\d{12}/)) {
        this.setCard('2'); // visa
      }
    } else if (enteredCard.length === 15 && enteredCard.match(/^3[47]\d{13}/)) {
      this.setCard('5'); // amex
    }
  }

  private setCard = (paymentType: string) => this.creditCardForm.get('paymentType').setValue(paymentType);

  getUserFirmCreditCards() {
    this.efilingService.getUserFirmCreditCard()
      .subscribe(result => {
        if (result.isSuccess) {
          this.firmCreditCard = result.data as CreditCard;
          if (this.firmCreditCard[0]) {
            if ((this.sCreditCard[0] && this.sCreditCard[0].nickName) && (this.firmCreditCard[0] && this.firmCreditCard[0].nickName)) {
              this.existingCardAvl = false;
              this.existingCCSelected = true;
              this.existingPersonalCreditCard = true;
              this.existingFirmCreditCard = true;
              this.newCCSelected = false;
              this.newCreditCard = true;
              this.errorMsgDisplay = false;
            }
            else if ((!this.sCreditCard[0] || (this.sCreditCard[0] && this.sCreditCard[0].nickName == null)) && (this.firmCreditCard[0] && this.firmCreditCard[0].nickName)) {
              this.existingCardAvl = false;
              this.existingCCSelected = true;
              this.existingPersonalCreditCard = false;
              this.existingFirmCreditCard = true;
              this.newCCSelected = false;
              this.newCreditCard = true;
              this.errorMsgDisplay = false;
            }
            else {
              this.existingFirmCreditCard = false;
              this.existingPersonalCreditCard = false;
              this.existingCardAvl = true;
              this.newCCSelected = true;
              this.newCreditCard = false;
              this.errorMsgDisplay = false;
            }

          }
          else {
            this.existingFirmCreditCard = false;
            if (this.sCreditCard[0]) {
              if (this.sCreditCard[0].nickName) {
                this.existingCardAvl = false;
                
                if(!this.isNewCreditCard)
                  this.existingPersonalCreditCard=true;
                else  
                  this.existingPersonalCreditCard=false;
                  
                this.existingCCSelected = true;
                this.newCreditCard = true;
                this.errorMsgDisplay = false;
              }
              else {
                this.existingCardAvl = true;
                this.existingPersonalCreditCard = false;
                this.newCCSelected = true;
                this.newCreditCard = false;
              }
            }
            else {
              this.existingCardAvl = true;
              this.newCCSelected = true;
              this.newCreditCard = false;
              this.errorMsgDisplay = false;
            }

          }

          this.creditCardForm.get('firstName').setValue(this.firmCreditCard.firstName);
          this.creditCardForm.get('lastName').setValue(this.firmCreditCard.lastName);
          this.creditCardForm.get('nickName').setValue(this.firmCreditCard.nickName);
          this.creditCardForm.get('address1').setValue(this.firmCreditCard.address1);
          this.creditCardForm.get('city').setValue(this.firmCreditCard.city);
          this.creditCardForm.get('state').setValue(this.firmCreditCard.state);
          this.creditCardForm.get('zipCode').setValue(this.firmCreditCard.zipCode);
          this.creditCardForm.get('expirationMonth').setValue(this.firmCreditCard.expirationMonth);
          this.creditCardForm.get('expirationYear').setValue(this.firmCreditCard.expirationYear);
          this.creditCardForm.get('rememberCreditCard').setValue(true);
          this.creditCardForm.get('paymentType').setValue(this.firmCreditCard.paymentType);

        }
        else
          console.error(result.message);
      }, error => console.error(error));
  }

  saveCCInVaultDB() {
    if (this.isFirmCard) {
      this.creditCardForm.get('isFirmCard').setValue(1);
    }
    else {
      this.creditCardForm.get('isFirmCard').setValue(0);
    }
    if (this.creditCardForm.get('rememberCreditCard').value == null) {
      this.creditCardForm.get('rememberCreditCard').setValue(false);
    }
    this.newCreditCard = true;
    if (this.newCCSelected) {
      if (!this.creditCardForm.valid) {
        return;
      }

      this.efilingService.addCreditCard(this.creditCardForm.value)
        .subscribe(result => {
          if (result.isSuccess) {
            this.creditCard = this.creditCardForm.value;
            this.creditCard.id = result.data as number;
            this.saveCreditCard.emit(this.creditCard);
            this.newCCSelected = false;
            this.errorMsgDisplay = false;
          }
          else {
            this.useThisCreditCard = false;
            this.errorMsgDisplay = true;
            this.errorMsg = result.message;
            this.snack.open(result.message, null, { duration: 10000, panelClass: ['red'] });
          }

        }, error => console.error(error));
    }
    this.useThisCreditCard = true;
    this.errorMsgDisplay = false;
    this.newCCSelected = false;
  }


  saveCreditCardToDB() {
    if (this.creditCardForm.get('rememberCreditCard').value == null) {
      this.creditCardForm.get('rememberCreditCard').setValue(false);
    }
    this.newCreditCard = true;
    if (this.newCCSelected) {
      if (!this.creditCardForm.valid) {
        return;
      }

      if (this.creditCard) {
        this.efilingService.rememberCreditCard(this.creditCard.id, this.creditCardForm.get('rememberCreditCard').value as boolean)
          .subscribe(result => {
            if (result.isSuccess) {
              let creditCard = this.creditCardForm.value;
              creditCard.nickName = this.creditCard.nickName;
              creditCard.id = this.creditCard.id;
              this.saveCreditCard.emit(this.creditCard);
              this.newCCSelected = false;
            }
            else
              console.error(result.message);
          }, error => console.error(error));
      }
      else {
        this.efilingService.addCreditCard(this.creditCardForm.value)
          .subscribe(result => {
            if (result.isSuccess) {
              this.creditCard = this.creditCardForm.value;
              this.creditCard.id = result.data as number;
              this.saveCreditCard.emit(this.creditCard);
              this.newCCSelected = false;
            }
            else
              console.error(result.message);
          }, error => console.error(error));
      }
      this.useThisCreditCard = true;
      this.creditCardForm.value.rememberCreditCard = false;
      this.creditCard = this.creditCardForm.value;
      this.creditCard.id = this.vaultIDFromNickName;
      this.saveCreditCard.emit(this.creditCard);
    }
    else {
      this.creditCard = this.creditCardForm.value;
      this.creditCard.id = this.vaultIDFromNickName;
      this.saveCreditCard.emit(this.creditCard);

    }
  }

  removeCreditCard(): void {
    this.creditCard = null;
    this.saveCreditCard.emit(null);
  }

  hideMessage() {
    //this.message="";
  }

  onCreditCardToggleChange(event: MatRadioChange): void {
    const val = event.value;
    this.existingCard = false;
    this.creditCardForm.get('paymentType').setValue(val);
    this.creditCardPaymentTypeChange.emit(val);
    this.creditCard = this.creditCardForm.value;
    this.creditCard.paymentType = val;
    this.creditCard.paymentTypeId = val;
    this.creditCardErrorMsg.emit(this.creditCardForm.valid);
    this.saveCreditCard.emit(this.creditCard);

  }
  onSelectRememberCreditCard(e) {
    if (e.checked) {
      this.creditCardForm.get('rememberCreditCard').setValue(true);
    }
    else {
      this.creditCardForm.get('rememberCreditCard').setValue(false);
    }
  }
  getUserCreditCard(){
    this.efilingService.getUserCreditCard()
    .subscribe(result => {
      if (result.isSuccess) {
        const creditCardLoaded = result.data;
        this.sCreditCard = creditCardLoaded;

      }
      else
        console.error(result.message);
    }, error => console.error(error));
  }
}
